"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Divider_1 = require("@material-ui/core/Divider");
const Grid_1 = require("@material-ui/core/Grid");
const Hidden_1 = require("@material-ui/core/Hidden");
const styles_1 = require("@material-ui/core/styles");
const Typography_1 = require("@material-ui/core/Typography");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const react_slick_1 = require("react-slick");
const Pagination_1 = require("../pagination/Pagination");
const RewardsScreenStyle_1 = require("./jss/RewardsScreenStyle");
const RewardCard_1 = require("./RewardCard");
const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false
};
class RewardSection extends React.Component {
    constructor() {
        super(...arguments);
        this.getNextPage = async (pageNumber) => {
            const { getNextPage, category } = this.props;
            if (getNextPage) {
                getNextPage(pageNumber, category);
            }
        };
        this.getPagination = () => {
            const { totalPages, activePage, lastPage, firstPage, classes } = this.props;
            return ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12, className: classes.centered }, { children: (0, jsx_runtime_1.jsx)(Pagination_1.default, { first: activePage === firstPage, last: activePage === lastPage, activePage: activePage, totalPages: totalPages, onSelect: this.getNextPage, maxButtons: 4, marginPagesDisplayed: 0 }) })));
        };
    }
    render() {
        const { category, classes, rewards, categoryRewards, onRewardSelect, totalPages, hideCategoryName, disableCornerIcon, t } = this.props;
        const sortedRewards = rewards.getSortedList();
        const sortedCategoryRewards = categoryRewards.getSortedList();
        return category && sortedRewards ? ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.sectionStyle }, { children: [hideCategoryName ? null : ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ component: "h2", variant: "h6", gutterBottom: true, className: classes.primaryColor, style: { marginTop: '20px' } }, { children: category.name })), (0, jsx_runtime_1.jsx)(Divider_1.default, { variant: "fullWidth", className: classes.divider, "aria-hidden": "true", style: { height: '1px' } })] })), (0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(Hidden_1.default, Object.assign({ smDown: true }, { children: (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, spacing: 4 }, { children: [sortedRewards.map(reward => {
                                        let banner = {};
                                        if (this.props.showSoldOutTag) {
                                            if (category.name === 'Coupons') {
                                                if (reward.remaining_coupons === 0) {
                                                    banner = {
                                                        showBanner: true,
                                                        bannerText: t('reward.soldOut'),
                                                        styleType: 'GrayedOut'
                                                    };
                                                }
                                            }
                                        }
                                        return ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12, sm: 12, md: 4 }, { children: (0, jsx_runtime_1.jsx)(RewardCard_1.default, { onRewardSelect: onRewardSelect, reward: reward, disableCornerIcon: disableCornerIcon, banner: banner }) }), reward.id));
                                    }), (0, jsx_runtime_1.jsx)("div", { style: { height: '10px', width: '100%' } }), totalPages > 1 && this.getPagination()] })) })), (0, jsx_runtime_1.jsx)(Hidden_1.default, Object.assign({ mdUp: true }, { children: (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12, className: classes.rewardCarousel }, { children: (0, jsx_runtime_1.jsx)(react_slick_1.default, Object.assign({}, settings, { className: classes.rewardHeader }, { children: sortedCategoryRewards.map(reward => {
                                        let banner = {};
                                        if (this.props.showSoldOutTag) {
                                            if (category.name === 'Coupons') {
                                                if (reward.remaining_coupons === 0) {
                                                    banner = {
                                                        showBanner: true,
                                                        bannerText: t('reward.soldOut'),
                                                        styleType: 'GrayedOut'
                                                    };
                                                }
                                            }
                                        }
                                        return ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12, sm: 12, md: 4 }, { children: (0, jsx_runtime_1.jsx)(RewardCard_1.default, { onRewardSelect: onRewardSelect, reward: reward, disableCornerIcon: disableCornerIcon, banner: banner }) }), reward.id));
                                    }) })) })) }))] }, category.id)] }))) : null;
    }
}
exports.default = (0, styles_1.withTheme)((0, styles_1.withStyles)(RewardsScreenStyle_1.default)((0, react_i18next_1.withTranslation)()(RewardSection)));
//# sourceMappingURL=RewardSection.js.map